// extracted by mini-css-extract-plugin
export default {"photoPost":"UserPhotoPost_photoPost__dyXcg","preview":"UserPhotoPost_preview__j9uDZ"};